import Attivita from './Attivita';
import {minutesToHuman} from '../Helpers'
import Moment from 'moment';

class AttivitaPerGiorno extends Attivita {

    createPdf(items){

        const columns = [
            {title: "Giorno", dataKey: "giorno"},
            {title: "Utente", dataKey: "ute"},
            //{title: "Num sessioni", dataKey: "ses"},
            //{title: "Durata Totale\n(minuti)", dataKey: "duratamin"},
            {title: "Durata Totale\n(h:m:s)", dataKey: "duratahms"},
        ];
        let rows = [];
        let durataPesataTot = 0;

        items.map((item) => {
            let it = {
                giorno: Moment(item.giorno).format("dddd DD/MM/YY"),
                ute: item.utente.username,
                //ses: item.numAttivita,
                //duratamin: item.durataPesata,
                duratahms: minutesToHuman(item.durataPesata),
            };
            rows.push(it);
            durataPesataTot += item.durataPesata;
            return 0;
        });
        rows.push({
            id: '',
            ute: '',
            duratahms: minutesToHuman(durataPesataTot),
        })


        super.createPdf(columns, rows,
            {
                createdCell: this.doDrawCell,
                drawRow: this.doDrawRow,
                columnStyles: {
                    ute: {halign: 'left', columnWidth: 'auto'},
                    duratahms: {halign: 'center'},
                },
                headerStyles: {
                    valign: 'middle',
                    halign: 'center',
                    //fillColor: [0x56, 0x9e, 0xdd],
                    //fillColor: [0xFF, 0xFF, 0xFF],
                    fillColor: false,
                    textColor: [0,0,0],
                    duratahms:{halign: 'center'},
                },
            });
    }


}

export default AttivitaPerGiorno;


/** WEBPACK FOOTER **
 ** ./src/pdf/AttivitaPerGiorno.js
 **/